export const buildIncludeParams = (
  includes?: string[],
): Record<string, string[]> => {
  if (!includes?.length) return {};
  return { 'include[]': includes };
};
